// extracted by mini-css-extract-plugin
export default {"Form":"form_Form__1rLvT"};